import { Link } from 'react-router-dom';

const styles = [
  { name: 'Korean Minimal', slug: 'Korean+Minimal' },
  { name: 'Multi-Layered', slug: 'Multi-Layered' },
  { name: 'Pearl-Accent', slug: 'Pearl-Accent' },
  { name: 'Charm / Personalised', slug: 'Charm%2FPersonalised' },
];

const occasions = [
  'Office Wear',
  'Daily Wear',
  'Campus & Active',
  'Date Night',
];

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="max-w-none mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://storage.readdy-site.link/project_files/4ae51fa3-40da-40a1-b133-2a5cd9cb4858/eeeb8ac8-0d7f-481e-9e59-4803245bf0d2_compressed_joviaa-logo.webp"
              alt="Joviaa"
              className="h-10 w-auto object-contain mb-3 mix-blend-screen"
            />
            <p className="text-sm text-background-50/70 leading-relaxed mb-4 max-w-xs">
              Premium gold-look jewellery engineered for real life. 316L steel,
              PVD gold plating, and a promise that stays.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://instagram.com/joviaa.in"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-50/60 hover:text-background-50 transition-colors"
                aria-label="Instagram"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-lg"></i>
                </div>
              </a>
              <a
                href="https://youtube.com/@joviaa"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-50/60 hover:text-background-50 transition-colors"
                aria-label="YouTube"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-youtube-line text-lg"></i>
                </div>
              </a>
              <a
                href="https://wa.me/919686543847"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-50/60 hover:text-background-50 transition-colors"
                aria-label="WhatsApp"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Shop by Style */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-accent-500 mb-4 whitespace-nowrap">
              Shop by Style
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {styles.map((style) => (
                <Link
                  key={style.name}
                  to={`/shop?style=${style.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {style.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Shop by Occasion */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-accent-500 mb-4 whitespace-nowrap">
              Shop by Occasion
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {occasions.map((occasion) => (
                <Link
                  key={occasion}
                  to={`/shop?occasion=${encodeURIComponent(occasion)}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {occasion}
                </Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-accent-500 mb-4">
              Company
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/about"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
              >
                About
              </Link>
              <Link
                to="/durability"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
              >
                Durability &amp; Quality
              </Link>
              <Link
                to="/faq"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
              >
                FAQ
              </Link>
              <Link
                to="/contact"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Get in Touch */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-accent-500 mb-4">
              Get in Touch
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <div className="flex flex-col gap-3">
              <a
                href="https://wa.me/919686543847"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-background-50/80 hover:text-background-50 transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-whatsapp-fill text-accent-500"></i>
                </div>
                Chat on WhatsApp
              </a>
              <a
                href="mailto:hello@joviaa.in"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
              >
                hello@joviaa.in
              </a>
              <p className="text-sm text-background-50/50">
                Mon-Sat, 10am-7pm
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-50/10">
        <div className="max-w-none mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
            <p className="text-xs text-background-50/40">
              &copy; 2026 Joviaa. All rights reserved.
            </p>
            <span className="hidden sm:inline text-background-50/20">|</span>
            <Link
              to="/terms"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors"
            >
              Cookie Policy
            </Link>
          </div>
          <p className="text-xs text-background-50/30">
            Imitation jewellery &middot; HSN 7117
          </p>
        </div>
      </div>
    </footer>
  );
}